"use strict";
var compare = require("./compare");
var gt = function(a, b, loose) {
    return compare(a, b, loose) > 0;
};
module.exports = gt;
